import React from 'react';
import './PrimaryCare.css';

const PrimaryCare = () => {
  return (
    <div className="primary-care-container">
      <h1>Primary Care Services</h1>
      <div className="container">
        <div className="request-container">
          {/* Left Column */}
          <div className="request-info">
            <div className="emergency-notice">
              <p>If you are experiencing a medical emergency to life or limb please <strong>DIAL 911 IMMEDIATELY</strong>.</p>
              <p>Medical emergencies may include, but are not limited to:</p>
              <ul>
                <li>Chest pain</li>
                <li>Symptoms of a stroke (e.g. facial drooping, arm/leg weakness or paralysis, speech difficulty)</li>
                <li>Shortness of breath</li>
                <li>Severe trauma or bleeding</li>
                <li>Severe abdominal pain</li>
                <li>Drug overdose/accidental poisonings</li>
              </ul>
              <p>Our team will review your request and contact you shortly to confirm your appointment.</p>
            </div>
          </div>

          {/* Right Column - Appointment Request Form */}
          <div className="request-form">
            <div className="office-form-container">
              <iframe 
                title="Primary Care Appointment Request Form"
                width="100%"
                height="800px"
                src="https://forms.office.com/Pages/ResponsePage.aspx?id=JvDATR8xuEKPc9pWetuIA152HT8sfctLv5FtWjZ0GVVUQVUyVURINjlFSTdZNkhGVlVVNkNLSkYxUS4u&embed=true" 
                frameBorder="0" 
                marginWidth="0" 
                marginHeight="0" 
                style={{ 
                  border: 'none',
                  maxWidth: '100%',
                  maxHeight: '100vh',
                  width: '100%',
                  height: '100%',
                  minHeight: '600px'
                }} 
                allowFullScreen 
                webkitallowfullscreen 
                mozallowfullscreen 
                msallowfullscreen>
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrimaryCare;
